var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmAssociatedPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "186px",
    height: "230px",
    viewBox: "0 0 186 230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration/video-legitimation_magenta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-43.1080452%",
    y1: "59.417479%",
    x2: "99.9994525%",
    y2: "49.9984731%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFE0",
    offset: "38.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEB",
    offset: "60.2894%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    stopOpacity: 0.24,
    offset: "97.627%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.2465872%",
    y1: "49.998119%",
    x2: "43.1707748%",
    y2: "49.998119%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCBD",
    offset: "39.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    offset: "60.76%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.18727053%",
    y1: "49.133166%",
    x2: "95.526713%",
    y2: "50.8613584%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.9944467%",
    y1: "29.1068077%",
    x2: "-19.9526944%",
    y2: "85.1126983%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D2EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.9944467%",
    y1: "29.1068077%",
    x2: "-19.9526944%",
    y2: "85.1126983%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4",
    offset: "28.41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBECEC",
    offset: "44.73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDEDE",
    offset: "57.99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACB",
    offset: "69.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCBD",
    offset: "75.95%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Operationsportal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Verbundene-Personen-\\xFCberpr\\xFCfen",
    transform: "translate(-1212, -768)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration/video-legitimation_magenta",
    transform: "translate(1212, 782.0996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "membership_application",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.498449,159.266756 L127.883342,127.32723 C126.199953,126.341726 124.290303,125.823763 122.348975,125.823763 L102.401723,125.823763 L161.279604,160.256845 C163.935919,161.810734 163.935919,165.693165 161.279604,167.247054 L102.401723,201.68472 L122.348975,201.68472 C124.290303,201.68472 126.199953,201.166757 127.883342,200.181252 L182.498449,168.241726 C185.910479,166.247798 185.910479,161.260685 182.498449,159.266756 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.044681,164.455554 C165.945125,162.901665 164.782139,161.288187 162.605499,160.013906 L109.936245,129.238652 C105.7685,126.804684 99.4603176,126.538827 95.8537023,128.651932 L41.1796319,160.660214 C39.455516,161.668638 38.6635992,163.039177 38.754104,164.455554 C38.8536592,166.009443 40.0166456,167.622921 42.1932854,168.897201 L94.862675,199.672456 C99.0304199,202.106424 105.338603,202.372281 108.945218,200.259175 L163.614627,168.255477 C165.338743,167.247054 166.135185,165.876514 166.044681,164.455554 Z",
    id: "Path",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.044681,163.305034 L166.049206,163.30045 L166.049206,158.01081 L144.676503,168.530502 L109.93172,148.233685 C105.763975,145.799717 99.4557924,145.53386 95.8491771,147.646966 L60.1540938,168.544253 L38.7541492,158.01081 L38.7541492,162.906248 C38.7489239,163.034593 38.7450987,163.167522 38.7541492,163.30045 C38.8537045,164.85434 40.0166456,166.467817 42.1932854,167.742098 L94.862675,198.517353 C97.0257392,199.782466 99.7635086,200.456276 102.401723,200.525032 C104.849877,200.584621 107.212052,200.121663 108.949743,199.104072 L163.619153,167.100374 C165.338743,166.09195 166.135185,164.725995 166.044681,163.305034 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.044681,158.01081 C165.945125,156.456921 164.782139,154.843443 162.605499,153.569163 L109.93172,122.798492 C105.763975,120.364524 99.4557924,120.098667 95.8491771,122.211773 L41.1796319,154.215471 C39.455516,155.223894 38.6635992,156.58985 38.754104,158.01081 C38.8536592,159.564699 40.0166456,161.178177 42.1932854,162.452458 L94.862675,193.227713 C99.0304199,195.66168 105.338603,195.927538 108.945218,193.814432 L163.614627,161.810734 C165.338743,160.797726 166.135185,159.431771 166.044681,158.01081 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.044681,156.938214 C165.945125,155.384325 164.782139,153.770847 162.605499,152.496567 L109.936245,121.721312 C105.7685,119.287344 99.4603176,119.021487 95.8537023,121.134593 L41.1796319,153.142875 C39.455516,154.151298 38.6635992,155.517254 38.754104,156.938214 C38.8536592,158.492103 40.0166456,160.105581 42.1932854,161.379862 L94.862675,192.155117 C99.0304199,194.589084 105.338603,194.854942 108.945218,192.741836 L163.614627,160.738138 C165.338743,159.72513 166.135185,158.359175 166.044681,156.938214 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#003DCC",
    points: "2.49332057 140.079205 106.696174 79.1383337 106.696174 1.46216838 2.49332057 62.398502"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#002D96",
    points: "2.49332057 140.079205 106.696174 79.1383337 106.696174 69.4666347 2.49332057 130.402922"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#002D96",
    points: "6.26148771e-15 60.9362878 2.49341108 62.398502 106.696174 1.46221422 104.198243 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#002D96",
    points: "3.13074385e-15 138.616991 2.49341108 140.079205 2.49341108 62.398502 3.13074385e-15 60.9362878"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#002D96",
    points: "3.13074385e-15 138.616991 2.49341108 140.079205 2.49341108 130.402922 3.13074385e-15 128.945292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1121057,75.3219088 C26.9324607,70.3737575 26.932687,65.0254455 24.1125582,63.3762145 C21.2924747,61.7269835 16.7199472,64.4011396 13.8995921,69.3492908 C11.0791918,74.2969837 11.0790108,79.6452958 13.8990943,81.2945267 C16.7192231,82.9437577 21.2917506,80.2696016 24.1121057,75.3219088 Z",
    id: "Path",
    fill: "#26B4DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0105778,67.44062 C17.6530062,68.2336076 16.5533731,70.1633637 16.5533731,71.7539227 C16.5533731,73.339898 17.6530062,74.4950014 19.0105778,73.7020138 C20.3681494,72.9090261 21.4677824,70.4658908 21.4677824,68.8799155 C21.4677824,67.2893564 20.3681494,66.6476323 19.0105778,67.44062 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.010442,74.4033265 C16.6482674,75.7876171 14.7295662,77.6990382 14.7295662,79.3446022 C14.7295662,80.9901661 16.6437422,81.2010183 19.010442,79.8213115 C21.3726167,78.4370209 23.2913179,75.9847181 23.2913179,74.3391541 C23.2913179,72.6935902 21.3726167,73.019036 19.010442,74.4033265 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#26B4DC",
    points: "37.844531 60.8262779 40.9940971 58.983613 40.9940971 55.3028669 37.844531 57.1455318"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "37.844531 65.992157 40.9940971 64.1540758 40.9940971 60.4687459 37.844531 62.3114109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#26B4DC",
    points: "50.6646681 53.4602019 53.8142343 51.617537 53.8142343 47.9367908 50.6646681 49.774872"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "50.6646681 58.626081 53.8142343 56.783416 53.8142343 53.1026699 50.6646681 54.9407511"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#26B4DC",
    points: "63.4846695 46.0941259 66.6342357 44.251461 66.6342357 40.5661311 63.4846695 42.408796"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "63.4846695 51.260005 66.6342357 49.41734 66.6342357 45.7320102 63.4846695 47.5746751"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#26B4DC",
    points: "37.844531 90.3089169 40.9940971 88.4708357 40.9940971 84.7855059 37.844531 86.6281708"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "37.844531 95.4793797 40.9940971 93.6367148 40.9940971 89.9513849 37.844531 91.7940499"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#26B4DC",
    points: "50.6646681 82.9428409 53.8142343 81.100176 53.8142343 77.4194299 50.6646681 79.2620948"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "50.6646681 88.10872 53.8142343 86.2660551 53.8142343 82.5853089 50.6646681 84.4279739"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#26B4DC",
    points: "63.4846695 75.5767649 66.6342357 73.7341 66.6342357 70.0487701 63.4846695 71.891435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "63.4846695 80.742644 66.6342357 78.899979 66.6342357 75.2192329 63.4846695 77.0573141"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "80.3185577 33.1175477 95.8582276 24.0646082 95.8627528 23.0057634 80.3230829 32.0632867"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "78.1690693 34.364326 79.3727828 33.6675969 79.377308 32.6087522 78.1735945 33.3054812"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "90.5863244 32.9296142 95.8582276 29.8814247 95.8627528 28.8225799 90.5908497 31.8707694"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "78.1690693 40.1260917 89.7898824 33.4063236 89.7944076 32.3474788 78.1735945 39.0672469"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "78.1690693 45.7320102 83.4409724 42.6838207 83.4454977 41.6249759 78.1735945 44.6731654"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "80.3185577 62.737699 95.8582276 53.6802216 95.8627528 52.6213768 80.3230829 61.6788542"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "78.1690693 63.9798935 79.3727828 63.2831645 79.377308 62.2243197 78.1735945 62.9210488"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "90.5863244 62.5451818 95.8582276 59.4969923 95.8627528 58.4381475 90.5908497 61.486337"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "78.1690693 69.7416593 89.7898824 63.0218911 89.7944076 61.9630463 78.1735945 68.6828145"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F1F5FF",
    points: "78.1690693 75.3475777 83.4409724 72.2993882 83.4454977 71.2405434 78.1735945 74.288733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1125582,104.377801 C26.9329133,99.42965 26.9331395,94.0813379 24.1130107,92.432107 C21.2928819,90.782876 16.7203997,93.4570321 13.8999994,98.4051833 C11.0796443,103.353335 11.0794181,108.701188 13.8995469,110.350878 C16.7196757,112.000109 21.2922032,109.325952 24.1125582,104.377801 Z",
    id: "Path",
    fill: "#26B4DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0105778,96.4923871 C17.6530062,97.2853747 16.5533731,99.2151308 16.5533731,100.80569 C16.5533731,102.391665 17.6530062,103.546769 19.0105778,102.753781 C20.3681494,101.960793 21.4677824,99.5176579 21.4677824,97.9316826 C21.4677824,96.3457073 20.3681494,95.6993994 19.0105778,96.4923871 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.010442,103.455094 C16.6482674,104.839384 14.7295662,106.750805 14.7295662,108.396369 C14.7295662,110.041933 16.6437422,110.252785 19.010442,108.873079 C21.3726167,107.488788 23.2913179,105.036485 23.2913179,103.390921 C23.2913179,101.745357 21.3726167,102.075387 19.010442,103.455094 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "92.5548033 158.317921 84.4636764 164.551812 91.9076941 170.680278 128.467098 147.005242 119.851043 140.945533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    points: "92.5548033 158.317921 84.4636764 164.551812 91.9076941 170.680278 128.467098 147.005242 119.851043 140.945533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9532576,159.537197 C93.6363353,157.451594 90.5365468,157.722034 92.5729042,161.256101 C94.3151211,164.276788 96.9126082,166.939943 99.0530461,166.01861 C100.102902,165.569404 100.021447,162.938335 100.021447,162.938335 C100.021447,162.938335 99.523671,162.750401 95.9532576,159.537197 Z",
    id: "Path",
    fill: "#7D7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9442071,158.8313 C93.6272849,156.745697 90.5274963,157.016138 92.5638537,160.550204 C94.3060707,163.570891 97.1071935,166.234046 99.2476314,165.312714 C100.297487,164.863507 100.007871,162.237022 100.007871,162.237022 C100.007871,162.237022 99.5146205,162.044505 95.9442071,158.8313 Z",
    id: "Path",
    fill: "#4F4E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8946628,95.2731113 C95.9894595,97.4916432 94.6680898,97.5833181 94.6680898,97.5833181 C94.6680898,97.5833181 101.912997,108.107593 102.44245,109.267281 C102.777318,110.00068 103.451578,111.779172 102.270491,117.15132 C101.532877,120.511204 98.3742603,121.492125 99.9716696,123.48147 C100.691183,124.3753 102.560106,126.135457 103.58281,124.604487 C111.474827,112.805931 105.732299,106.677465 103.442528,100.801106 C102.790893,99.1280397 100.82694,93.7971458 98.8946628,95.2731113 Z",
    id: "Path",
    fill: "#91CC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8853012,124.017768 C94.8853012,124.017768 94.5006559,129.903294 94.5821102,136.040927 C94.6952412,144.516269 93.9621525,155.911456 95.3830775,160.953574 C95.9939847,163.117101 99.921892,164.473889 100.139103,162.539549 C100.695708,157.671613 99.9716696,149.553803 100.555425,145.263419 C101.351867,139.396227 103.886001,128.789445 103.600911,121.771733 C103.514932,119.493613 94.8853012,124.017768 94.8853012,124.017768 Z",
    id: "Path",
    fill: "#003DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3099738,164.968933 C82.5902275,163.88717 81.0425959,165.014771 84.2147882,167.265389 C87.6901716,169.731443 90.4958196,171.734539 92.2018346,170.066056 C92.7674895,169.511423 92.4823994,167.430403 92.4823994,167.430403 C92.4823994,167.430403 90.8985659,166.298219 86.3099738,164.968933 Z",
    id: "Path",
    fill: "#7D7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3054486,164.350128 C82.5857023,163.268364 81.0380706,164.395965 84.210263,166.646583 C87.6856464,169.112637 90.4912944,171.115733 92.1973094,169.447251 C92.7629643,168.892618 92.4778742,166.811598 92.4778742,166.811598 C92.4778742,166.811598 90.8940406,165.683997 86.3054486,164.350128 Z",
    id: "Path",
    fill: "#4F4E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2019124,121.130009 C92.0253503,128.629014 87.0475877,136.88892 86.5362357,141.894368 C86.011308,147.060247 86.8892043,162.489128 87.4231825,165.395221 C87.7082726,166.926192 92.170158,169.011795 92.5412276,167.201216 C93.5141539,162.447874 92.6045809,151.451473 93.1883367,146.193919 C93.7449411,141.147217 100.795263,130.861297 102.650611,120.277433 C103.134811,117.513435 93.6363353,118.356844 93.2019124,121.130009 Z",
    id: "Path",
    fill: "#003DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7498551,93.9575769 C97.2746273,93.3066853 92.9575495,95.1447665 90.9257173,95.868998 C89.1608742,96.4923871 86.9978101,99.1097047 86.4955086,100.691096 C85.1831893,104.816466 87.1969206,107.323773 87.6630202,112.494236 C88.1245945,117.614278 84.4636764,133.299848 84.4636764,142.724025 C84.4636764,146.510198 101.478574,145.799717 102.324794,140.679676 C105.433633,121.831322 104.225394,107.090002 103.451578,103.134232 C101.97635,95.5710546 101.238736,95.0485078 98.7498551,93.9575769 Z",
    id: "Path",
    fill: "#91CC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1838115,88.6175155 C92.2561375,87.0682102 90.9076164,93.3937764 90.9076164,93.3937764 C90.9076164,93.3937764 92.2335113,95.1676852 90.9302426,95.8644142 C94.7042917,96.1211039 96.8266287,93.9392419 96.8266287,93.9392419 C95.8175004,93.9713281 95.1160884,91.8398873 93.1838115,88.6175155 Z",
    id: "Path",
    fill: "#FBB982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.360218,85.8764368 C90.7718592,85.4914024 88.9889151,86.6923432 88.6676232,88.6220993 C88.3553817,90.4830992 88.4775632,92.9995744 90.065922,93.3846089 C91.6542808,93.7696434 93.9666778,91.9269784 94.4146764,90.0247248 C94.8672003,88.1178875 93.9485768,86.2614713 92.360218,85.8764368 Z",
    id: "Path",
    fill: "#FBB982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2200134,85.3309714 C91.7312098,84.9551044 90.9257173,84.8130083 89.251379,85.4455649 C88.5816436,85.6976708 87.7127978,85.0192768 87.7127978,85.0192768 C87.7127978,85.0192768 87.1426177,86.5135772 88.2694022,87.4944983 C89.3916614,88.4754195 89.0522685,88.6587692 89.83966,89.8092889 C90.6270516,90.9598085 91.5502003,91.8215523 91.9122194,91.9498972 C92.2742385,92.078242 93.6815877,91.1248233 94.8038469,91.5465277 C95.6183899,89.4150869 95.9668333,86.0231166 93.2200134,85.3309714 Z",
    id: "Path",
    fill: "#4F4E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0002357,78.4691071 C58.9865822,77.8136318 59.0680365,78.7716342 59.5205604,79.2254248 C59.9730842,79.6837992 61.163222,80.6601366 60.955061,80.9259937 C60.7514253,81.1964346 59.1902179,83.4378852 60.7287991,84.2675428 C62.2673803,85.0972004 63.3534376,85.5326561 63.3534376,85.5326561 L65.8830461,83.7495798 C63.8150119,81.4072868 61.0138892,79.1245825 60.0002357,78.4691071 Z",
    id: "Path",
    fill: "#FBB982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5772739,89.4013357 C90.3102848,89.2179859 89.9482657,89.2913258 89.7717814,89.5617667 L89.328308,90.2264095 C89.1472985,90.4968504 89.2197023,90.8635499 89.4866914,91.0423159 C89.7536805,91.2256657 90.1156996,91.1523258 90.2921839,90.8818849 L90.7356573,90.2172421 C90.9121416,89.9513849 90.844263,89.5846854 90.5772739,89.4013357 Z",
    id: "Path",
    fill: "#FBB982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2422507,97.9179314 C84.9705031,99.3480594 78.9609861,94.9293305 76.0241061,93.2425129 C74.6031811,92.4266065 67.1093858,84.6067399 65.4486231,83.4012153 C63.7878605,82.1956907 61.7379274,84.6067399 62.9687923,86.0047817 C64.1996572,87.4074072 68.9556832,93.7375572 70.8381825,95.8873329 C72.725207,98.0325249 85.0202807,106.113665 86.5633872,106.824145 C88.0974431,107.539209 91.7221593,96.3961285 88.2422507,97.9179314 Z",
    id: "Path",
    fill: "#91CC64"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmAssociatedPeople);
export default __webpack_public_path__ + "static/media/confirm-associated-people.7ca219f9ca2bb41218f0ecf696fb8d8a.svg";
export { ForwardRef as ReactComponent };